import * as React from 'react';
import { connect } from 'react-redux';
import { ComponentRoot } from '../components';
import {
    EComponentTypes, IComponent, IControl, IComponentIdHolder, ISearchLocation, EModalType, IComponentType, ElementsHelper, clone, EConfirmationOperationType,
    ComponentHelper, PropertyHelper, RenewToken, IOutputReference, ILoopConfig, IBranch, ControlHelper
} from '../helpers';
import store from '../store/store';
import types from '../store/types';

class ComponentListContainer extends React.Component<any, any> {

    getProperties = (): any => {
        return {
            components: this.props.state.components,
            StartId: this.props.parentComponentId ? this.props.StartId : this.props.state.StartId,
            searchLocation: this.props.searchState.searchLocation,
            preventBlur: this.props.searchState.preventBlur
        };
    }

    addBranchOnly = () => {
        if (store.getState().modalState.decisionConfig.branchEditIndex !== 0 && !store.getState().modalState.decisionConfig.branchEditIndex) {

            let branchTemplate: IBranch = this.props.cache.componentTemplates
                .filter(ct => ct.Decision)[0]
                .Decision.Branches[0];

            store.dispatch({
                type: types.ADD_BRANCH,
                branch: branchTemplate,
                componentId: this.props.state.componentId
            });
        }
    }

    deleteBranch = (branchIndex: number, componentId?) => {

        // Confirmation pop-up before deletion
        store.dispatch({
            type: types.TOGGLE_CONFIRMATION_DIALOG,
            operationType: EConfirmationOperationType.DeleteDecisionBranch,
            title: 'Confirm Deletion',
            message: 'Are you sure you want to delete this decision branch and all of its child components',
            isOpen: true,
            okButtonLabel: 'Delete',
            cancelButtonLabel: 'Cancel',
            branchIndex: branchIndex,
            componentId: componentId
        });

        // store.dispatch({
        //     type: types.DELETE_BRANCH,
        //     branchIndex: branchIndex,
        //     componentId: componentId
        // });
        RenewToken();

    }


    toggleDialog = (componentId: string, controlIndex: number, previousOutputBlocks: any, layoutPanelIndex?: number) => {

        let component: IComponent = this.props.state.components[componentId];

        let control: IControl = controlIndex === null
            ? null
            :
            (layoutPanelIndex !== null && layoutPanelIndex !== undefined) ?
                component.ControlBlock.LayoutPanels[layoutPanelIndex].Controls[controlIndex]
                :
                component.ControlBlock.Controls[controlIndex];

        let isRepeatable: boolean = !!(PropertyHelper.getPropertyValue(component.ControlBlock.Properties, 'Is Repeatable'));

        store.dispatch(
            {
                type: types.TOGGLE_DIALOG,
                openModal: EModalType.ControlConfig,
                control: control,
                componentId: componentId,
                controlIndex: controlIndex,
                layoutPanelIndex: layoutPanelIndex,
                previousOutputBlocks: previousOutputBlocks,
                isRepeatable: isRepeatable,
                parentLoopId: component.ParentLoopId
            }
        );

        RenewToken();

        store.dispatch({
            type: types.SET_PREVIOUS_OUTPUT_BLOCKS,
            previousOutputBlocks: previousOutputBlocks
        });
    }

    toggleActionConfigDialog = (componentId: string, previousOutputBlocks: any) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.ActionConfig,
            componentId: componentId,
            action: components[componentId].Action,
            previousOutputBlocks: previousOutputBlocks || {},
            parentLoopId: components[componentId].ParentLoopId
        });

        PropertyHelper.updatePropertyFilterState(ComponentHelper.getProperties(components[componentId]));

        store.dispatch({
            type: types.SET_PREVIOUS_OUTPUT_BLOCKS,
            previousOutputBlocks: previousOutputBlocks
        });
    }

    toggleControlBlockLoopingDialog = (componentId: string, previousOutputBlocks: any) => {

        let { components } = this.getProperties();

        let controlBlock = components[componentId] ? components[componentId].ControlBlock : null;

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.Blank
        });

        RenewToken();

        store.dispatch({
            type: types.SET_PREVIOUS_OUTPUT_BLOCKS,
            previousOutputBlocks: previousOutputBlocks
        });

        store.dispatch({
            type: types.SET_MODAL_OVERLAY_MESSAGE,
            overlayMessage: 'Loading...'
        });

        ComponentHelper.getAllOutputReferences(controlBlock).then(
            (allOutputReferences: IOutputReference[]) => {

                store.dispatch({
                    type: types.TOGGLE_DIALOG,
                    openModal: EModalType.ControlBlockLooping,
                    componentId: componentId,
                    controlBlock: components[componentId].ControlBlock,
                    allOutputReferences: allOutputReferences
                });

                store.dispatch({
                    type: types.SET_MODAL_OVERLAY_MESSAGE,
                    overlayMessage: null
                });

            },
            () => {

                store.dispatch({
                    type: types.SET_MODAL_OVERLAY_MESSAGE,
                    overlayMessage: null
                });
            });

    }

    toggleGlobalOutputsDialog = () => {
        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.GlobalOutputs });
        RenewToken();
    }

    toggleJourneySummaryDialog = () => {

        let { outputs, globalOutputs } = this.props;

        store.dispatch({ type: types.SET_SUMMARY_OUTPUTS, outputs: outputs, globalOutputs: globalOutputs });
        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.Summary });
        RenewToken();
    }

    toggleDecisionConfigDialog = (componentId: string, previousOutputBlocks: any) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.DecisionConfig,
            componentId: componentId,
            decision: components[componentId].Decision,
            previousOutputBlocks: previousOutputBlocks || {},
            parentLoopId: components[componentId].ParentLoopId
        });

        RenewToken();

        store.dispatch({
            type: types.SET_PREVIOUS_OUTPUT_BLOCKS,
            previousOutputBlocks: previousOutputBlocks,
        });

    }
    toggleNewComponentDialog = () => {

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.AddComponent,
        });

        RenewToken();
    }

    toggleSubmissionDialog = (componentId: string) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.SubmissionConfig,
            componentId: componentId,
            submission: components[componentId].Submission
        });

        RenewToken();

    }

    toggleSharedJourneyConfig = (componentId: string, previousOutputBlocks: any) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.SharedJourneyConfig,
            sharedJourney: clone(components[componentId].SharedJourney),
            previousOutputBlocks: previousOutputBlocks
        });

        RenewToken();

    }

    toggleRedirectConfigDialog = (componentId: string) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.RedirectConfig,
            componentId: componentId,
            redirect: clone(components[componentId].Redirect)
        });

        RenewToken();
    }

    toggleLoopConfigDialog = (componentId: string, previousOutputBlocks: any) => {

        let { components } = this.getProperties();

        store.dispatch({
            type: types.TOGGLE_DIALOG,
            openModal: EModalType.LoopConfig,
            componentId: componentId
        });

        let component: IComponent = components[componentId];

        let loopConfig: ILoopConfig = {
            componentId: componentId,
            OutputValues: component.Loop.OutputValues,
            Properties: component.Loop.Properties,
            previousOutputBlocks: previousOutputBlocks,
            summaryColumns: component.Loop.SummaryColumns || [],
            editedValidationItem: null,
            validationEditIndex: null,
            overIndex: null,
            fromIndex: null
        };

        store.dispatch({
            type: types.SET_LOOP_CONFIG,
            loopConfig: loopConfig
        });

        RenewToken();

    }

    deleteComponent = (componentId: string) => {

        let { components } = this.getProperties();

        let deletedComponent: IComponent = components[componentId];
        let deletedComponentId: string = components[componentId].Id;

        let deletedComponentOutputs = this.props.outputs.filter(x => x.componentId === deletedComponentId).map(x => x.Id);
        let isDeletedOutputUsed = false;
        let outputsInUse = store.getState().outputsState.outputsInUse;
        Object.keys(outputsInUse).forEach(element => {
            outputsInUse[element].filter(x => deletedComponentOutputs.includes(x)).length ? isDeletedOutputUsed = true : null;
        });
        let confirmationMessage;
        if (deletedComponentOutputs.length && isDeletedOutputUsed) {
            confirmationMessage = 'One or more outputs from this component are used as value in the journey. Saving the changes will remove the values in those places and cannot be reverted. Are you sure you want to proceed?';

            // store.dispatch({
            //     type: types.TOGGLE_CONFIRMATION_DIALOG,
            //     operationType: EConfirmationOperationType.CascadeOutputValues,
            //     title: 'Confirm Deletion',
            //     message: 'One or more outputs from this component are used as value in the journey. Saving the changes will remove the values in those places and cannot be reverted. Are you sure you want to proceed?',
            //     isOpen: true,
            //     deletedOutputs: deletedComponentOutputs,
            //     componentId: deletedComponentId,
            //     action: deletedComponent,
            // })
        }

        if (deletedComponent.ComponentType.ComponentTypeId === EComponentTypes.decision) {

            store.dispatch({
                type: types.TOGGLE_CONFIRMATION_DIALOG,
                operationType: EConfirmationOperationType.DeleteDecision,
                title: 'Confirm Deletion',
                message: confirmationMessage ? confirmationMessage : 'Are you sure you want to delete this decision component and all of its child components',
                isOpen: true,
                okButtonLabel: 'Delete',
                cancelButtonLabel: 'Cancel',
                componentId: deletedComponentId,
                deletedOutputs: deletedComponentOutputs
            });

        }
        else if (deletedComponent.ComponentType.ComponentTypeId === EComponentTypes.loop) {

            store.dispatch({
                type: types.TOGGLE_CONFIRMATION_DIALOG,
                operationType: EConfirmationOperationType.DeleteLoop,
                title: 'Confirm Deletion',
                message: confirmationMessage ? confirmationMessage : 'Are you sure you want to delete this loop component and all of its child components',
                isOpen: true,
                okButtonLabel: 'Delete',
                cancelButtonLabel: 'Cancel',
                componentId: deletedComponentId,
                deletedOutputs: deletedComponentOutputs
            });

        }
        else {

            // if the component is part of a loop, and is the first component in that loop...
            if (deletedComponent.ParentLoopId && components[deletedComponent.ParentLoopId] && components[deletedComponent.ParentLoopId].Loop.FirstLoopComponent &&
                components[deletedComponent.ParentLoopId].Loop.FirstLoopComponent.ComponentId === componentId) {
                let firstLoopComponentId = deletedComponent.NextComponent ? deletedComponent.NextComponent.ComponentId : null;
                store.dispatch({
                    type: types.TOGGLE_CONFIRMATION_DIALOG,
                    operationType: EConfirmationOperationType.DeleteFirstLoopComponent,
                    title: 'Confirm Deletion',
                    message: confirmationMessage ? confirmationMessage : 'Are you sure you want to delete this component?',
                    isOpen: true,
                    okButtonLabel: 'Delete',
                    cancelButtonLabel: 'Cancel',
                    deletedComponentId: deletedComponentId,
                    firstLoopComponentId: deletedComponent.NextComponent ? deletedComponent.NextComponent.ComponentId : null,
                    componentId: components[deletedComponent.ParentLoopId].Id,
                    deletedOutputs: deletedComponentOutputs
                });

                // store.dispatch({
                //     type: types.SET_FIRST_LOOP_COMPONENT_ID,
                //     componentId: components[deletedComponent.ParentLoopId].Id,
                //     firstLoopComponentId: deletedComponent.NextComponent ? deletedComponent.NextComponent.ComponentId : null
                // });

            }
            else {

                let newNextComponent: IComponentIdHolder = components[componentId].NextComponent;
                // store.dispatch({ type: types.REPLACE_NEXT_COMPONENT, componentIdToReplace: deletedComponentId, newNextComponent: newNextComponent });

                store.dispatch({
                    type: types.TOGGLE_CONFIRMATION_DIALOG,
                    operationType: EConfirmationOperationType.DeleteAction,
                    title: 'Confirm Deletion',
                    message: confirmationMessage ? confirmationMessage : 'Are you sure you want to delete this component?',
                    isOpen: true,
                    okButtonLabel: 'Delete',
                    cancelButtonLabel: 'Cancel',
                    deletedComponentId: deletedComponentId,
                    newNextComponent: newNextComponent,
                    deletedOutputs: deletedComponentOutputs
                });

            }
        }

        RenewToken();

    }

    closeSearchBox = () => {

        let { preventBlur } = this.getProperties();

        if (!preventBlur)
            store.dispatch({
                type: types.CLOSE_SEARCH_LOCATION,
                searchLocation: this.props.searchState.searchLocation
            });

    }

    setSearchLocation = (searchLocation: ISearchLocation, elementId: string, passedSubmissionComponent: boolean): void => {

        if (!searchLocation)
            this.closeSearchBox();

        else {

            store.dispatch({
                type: types.SET_SEARCH_LOCATION,
                searchLocation: searchLocation
            });

            store.dispatch({
                type: types.SET_ACTIVE_SEARCH_LOCATION,
                elementId: elementId
            });

            store.dispatch({
                type: types.GET_SUGGESTIONS,
                search: '',
                componentTypes: this.props.cache.componentTypes,
                passedSubmissionComponent: passedSubmissionComponent,
                isSharedJourney: this.props.isSharedJourney
            });

        }

        RenewToken();

        // this.toggleNewComponentDialog();

    }

    toggleSidebar = (component: IComponent, keepOpen?: boolean, previousOutputBlocks?: any, isLayoutPanel?: boolean, layoutPanelIndex?: number) => {
        store.dispatch({
            type: types.TOGGLE_SIDEBAR,
            componentId: component.Id,
            keepOpen: keepOpen,
            previousOutputBlocks: previousOutputBlocks,
            isLayoutPanel: isLayoutPanel,
            layoutPanelIndex: layoutPanelIndex,

        });
    };

    toggleComponentMenu = (componentId: string) => {
        store.dispatch({
            type: types.TOGGLE_COMPONENT_MENU,
            componentId: componentId
        });
        RenewToken();
    }

    updateProperty = (key: string, value: any, componentId: string) => {
        store.dispatch({
            type: types.UPDATE_PROPERTY,
            componentId: componentId,
            key: key, value: value
        });
        RenewToken();
    }

    updateComponentName = (key: string, value: any, componentId?: string) => {
        store.dispatch({
            type: types.UPDATE_PROPERTY,
            componentId: componentId,
            key: key,
            value: value
        });

        // update the component output value 
        store.dispatch({
            type: types.UPDATE_COMPONENT_OUTPUT,
            componentId: componentId,
            key: key
        });

        let actionToUpdate = store.getState().processState.components[componentId].Action;

        // sync outputstate values with component output values
        if (actionToUpdate) {
            store.dispatch({
                type: types.UPDATE_ACTION_IN_OUTPUT,
                componentId: componentId,
                action: actionToUpdate
            })
        }

    }

    updateComponentOutput = (key: string, value: any, componentId?: string) => {
        store.dispatch({
            type: types.UPDATE_COMPONENT_OUTPUT,
            componentId: componentId,
            key: key,
            value: value
        });
    }

    setNextComponentId = (elementId: string, componentId: string, nextComponentId: string, elementType: string) => {
        store.dispatch({
            type: types.SET_NEXT_ACTIVE_ELEMENT,
            element: elementType,
            elementId: elementId,
            nextElementId: nextComponentId,
            componentId: componentId
        });
    }

    getActiveElement = (componentId: string): any => {
        return this.props.activeState.elements[componentId];
    }

    updateSuggestions = (value: string, passedSubmissionComponent: boolean = false) => {
        store.dispatch({
            type: types.GET_SUGGESTIONS,
            search: value,
            componentTypes: this.props.cache.componentTypes,
            passedSubmissionComponent: passedSubmissionComponent,
            isSharedJourney: this.props.isSharedJourney
        });
    }

    selectItem = (type: IComponentType, passedSubmissionComponent: boolean = false) => {

        let searchLocation: ISearchLocation = this.props.searchState.searchLocation;
        let components = this.props.state.components;
        let { componentTemplates, componentTypes } = this.props.cache;
        let elementsHelper: ElementsHelper = new ElementsHelper(components, componentTemplates, componentTypes, this.props.activeState.elements);

        store.dispatch({
            type: types.SET_PREVENT_SEARCH_BLUR,
            preventBlur: true
        });

        elementsHelper.AddElement(searchLocation, type, passedSubmissionComponent);

        setTimeout(() => {

            store.dispatch({
                type: types.SET_PREVENT_SEARCH_BLUR,
                preventBlur: false
            });

        }, 0);

        RenewToken();

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });


    }

    addNewLayoutPanel = (componentId: string) => {
        ControlHelper.addNewLayoutPanel(componentId);
    }

    public render() {

        let { components, StartId, searchLocation, preventBlur } = this.getProperties();
        let previousOutputBlocks: any = this.props.previousOutputBlocks || {};
        let { branchId, parentComponentId } = this.props;
        let { suggestions, term } = this.props.searchState;

        return (
            <ComponentRoot key='component-list_root'
                components={components}
                searchLocation={searchLocation}
                StartId={StartId}
                branchId={branchId}
                parentComponentId={parentComponentId}
                previousOutputBlocks={previousOutputBlocks}
                toggleSidebar={this.toggleSidebar}
                toggleMenu={this.toggleComponentMenu}
                updateProperty={this.updateProperty}
                toggleDialog={this.toggleDialog}
                toggleActionConfigDialog={this.toggleActionConfigDialog}
                toggleControlBlockLoopingDialog={this.toggleControlBlockLoopingDialog}
                toggleDecisionConfigDialog={this.toggleDecisionConfigDialog}
                toggleGlobalOutputsDialog={this.toggleGlobalOutputsDialog}
                toggleJourneySummaryDialog={this.toggleJourneySummaryDialog}
                toggleSubmissionConfigDialog={this.toggleSubmissionDialog}
                toggleSharedJourneyConfig={this.toggleSharedJourneyConfig}
                toggleRedirectConfigDialog={this.toggleRedirectConfigDialog}
                toggleLoopConfigDialog={this.toggleLoopConfigDialog}
                deleteComponent={this.deleteComponent}
                setSearchLocation={this.setSearchLocation}
                setNextComponentId={this.setNextComponentId}
                getActiveElement={this.getActiveElement}
                selectItem={this.selectItem}
                suggestions={suggestions}
                term={term}
                updateSuggestions={this.updateSuggestions}
                preventBlur={preventBlur}
                addBranchOnly={this.addBranchOnly}
                deleteBranch={this.deleteBranch}
                toggleNewComponentDialog={this.toggleNewComponentDialog}
                updateComponentName={this.updateComponentName}
                addNewLayoutPanel={this.addNewLayoutPanel}
            />
        );
    }
}

let mapStateToProps = (store) => {
    return {
        activeState: store.activeProcessState,
        state: store.processState,
        searchState: store.searchState,
        cache: store.cacheState,
        outputs: store.outputsState.outputs,
        globalOutputs: store.outputsState.globalOutputs,
        isSharedJourney: store.toolsState.isSharedJourney
    };
};

export default connect<any, any, any>(mapStateToProps)(ComponentListContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/component-list.tsx